import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'employeeNotifyAdm': [],
  'employeeNotifyEva': [],
  'employeeNotifyGes': [],
  'employeeNotifyTec': [],
  'loading': false,
};

export const wtsEmployeeNotify = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_EMPLOYEE_NOTIFY_ADM]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_ADM]: (state, action) => ({
      ...state,
      'loading': false,
      'employeeNotifyAdm': action.response?.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_ADM_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'employeeNotifyAdm': [],
    }),
    [ActionTypes.FETCHING_WTS_EMPLOYEE_NOTIFY_EVA]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_EVA]: (state, action) => ({
      ...state,
      'loading': false,
      'employeeNotifyEva': action.response?.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_EVA_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'employeeNotifyEva': [],
    }),
    [ActionTypes.FETCHING_WTS_EMPLOYEE_NOTIFY_GES]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_GES]: (state, action) => ({
      ...state,
      'loading': false,
      'employeeNotifyGes': action.response?.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_GES_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'employeeNotifyGes': [],
    }),
    [ActionTypes.FETCHING_WTS_EMPLOYEE_NOTIFY_TEC]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_TEC]: (state, action) => ({
      ...state,
      'loading': false,
      'employeeNotifyTec': action.response?.data || action.response || [],
    }),
    [ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_TEC_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'employeeNotifyTec': [],
    }),
  })(state, action);
};
